import {useState} from "react";
import DiscountFormState from "./interface/DiscountFormState";
import DiscountFormController from "./Controller/DiscountFormController";
import AppSettingController from "../../../Main/controller/AppSettingController";
import marketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";

export default function DiscountForm() {
    const {t, i18n} = useTranslation();
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    const setting = AppSettingController.getSetting() as marketSettingLocalStorage;
    const currency = setting.currency || t("currency.default");
    const [state, setState] = useState<DiscountFormState>({
        error: false,
        discountCode: "",
        discountPercentage: "",
        discountPrice: "",
        discountPriceSeparator: "",
        type: "percentage",
        message: "",
    })

    return (
        <form className="add-discount-form" onSubmit={e => new DiscountFormController(state, setState).addDiscount(e)}>
            <h3>{t("setting.addDiscount")}</h3>
            <div className="inputs-container">
                <label>
                    <input type="text"
                           placeholder={t("setting.discountCode")}
                           value={state.discountCode}
                           onChange={e => new DiscountFormController(state, setState).setDiscountCode(e)}/>
                </label>
                <select onChange={e => new DiscountFormController(state, setState).changeType(e)}>
                    <option value="percentage">{t("percentage")}</option>
                    <option value="price">{t("price")}</option>
                </select>
                <label className={'price-discount'}>
                    {state.type === "percentage" ?
                        <input type="text" value={state.discountPercentage}
                               placeholder={t("setting.discountPercentage")}
                               inputMode={'numeric'}
                               onChange={e => new DiscountFormController(state, setState).setDiscount(e)}/> :
                        <input type="text" value={state.discountPrice}
                               placeholder={t("setting.discountPrice")}
                               inputMode={'numeric'}
                               onChange={e => new DiscountFormController(state, setState).setDiscount(e)}/>
                    }
                    {state.type === "price" ? <p>{Number(state.discountPrice).toLocaleString(lang)}{currency}</p> : null}
                </label>
                <button type="submit" onClick={e => new DiscountFormController(state, setState).addDiscount(e)}>
                    {t("add")}
                </button>
            </div>
            {state.error ? <p className={'error'}>{state.message}</p> : null}
        </form>
    );
}